import gsap from "gsap";
import AssetsManager from "js/components/AssetsManager";
import { Container, Sprite } from "pixi.js";


export default class RewardEffect extends Container {

    constructor() {
        super();
    }


    add(type, from, to, callback, time = 0) {


        switch (type) {
            case "coins":
                this.texture = AssetsManager.texturesPixi.coinsGold;
                this.color = 0xeccb00;
                this.time = time > 0 ? time : .6;
                this.scaleVal = .15;
                break;

            case "booster":
                this.texture = AssetsManager.texturesPixi.arrow;
                this.color = 0x95fb04;
                this.time = 1;
                this.scaleVal = .24;
                break;

            case "shield":
                this.texture = AssetsManager.texturesPixi.shield;
                this.color = 0x3effff;
                this.time = .8;
                this.scaleVal = .2;
                break;

            default:
                break;
        }


        this.coins = new Sprite(this.texture);
        this.coins.scale.set(this.scaleVal);
        this.coins.anchor.set(.5);
        this.coins.x = from.x;
        this.coins.y = from.y;

        this.circle = new Sprite(AssetsManager.texturesPixi.circle);
        this.circle.scale.set(0);
        this.circle.anchor.set(.5);
        this.circle.tint = this.color;
        this.coins.addChild(this.circle);

        gsap.to(this.coins, {
            duration: this.time, x: to.x, y: to.y, onComplete: (coins, circle) => {

                gsap.to(circle, {
                    duration: .6, alpha: 0, onComplete: () => {
                        circle.destroy();
                        coins.destroy();
                    }
                });
                gsap.to(circle.scale, {
                    duration: .2, x: 2, y: 2
                });

                coins.texture = null;
                callback && callback();

            },
            onCompleteParams: [this.coins, this.circle]
        });
        this.addChild(this.coins);

    }


}


